import * as v from 'valibot'

const REQUIRED = 'This field is required'

export const DATE_OF_BIRTH_MIN = '1900-01-01'

// ISO date (YYYY-MM-DD) as produced by the native date input.
export const DateOfBirthSchema = v.pipe(
  v.string(REQUIRED),
  v.trim(),
  v.nonEmpty(REQUIRED),
  v.maxLength(10),
  v.isoDate('Please enter a valid date'),
  v.check(value => value >= DATE_OF_BIRTH_MIN && new Date(value) < new Date(), 'Please enter a valid date of birth'),
)
